var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypingLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 80,
    viewBox: "0 0 220 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 3,
    floodColor: "#ff4d7a",
    floodOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF5E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF3366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF2D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF0F7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF0099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D500F9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 10,
    fill: "url(#g1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "30;50;30",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 30,
    r: 10,
    fill: "url(#g2)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "30;50;30",
    dur: "1s",
    begin: "0.15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 30,
    r: 10,
    fill: "url(#g3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "30;50;30",
    dur: "1s",
    begin: "0.30s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 30,
    r: 10,
    fill: "url(#g4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "30;50;30",
    dur: "1s",
    begin: "0.45s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 30,
    r: 10,
    fill: "url(#g5)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "30;50;30",
    dur: "1s",
    begin: "0.60s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypingLoader);
export default __webpack_public_path__ + "static/media/typingLoader.1a3732c5e52b4fd8e6c1c8ff00c2b6b3.svg";
export { ForwardRef as ReactComponent };